import './style.sass';

import clsx from 'clsx';
import React from 'react';
import FullWrapper from '../../cases/reusable-components/layouts-components__common-cases/full-wrapper';

const DefaultDotList = ({ listCreateDotProject, customClass }) => {
    return (
        <FullWrapper className="default-dotList">
            <div className="default-dotListWrapper">
                {listCreateDotProject.title && (
                    <div className="default-dotListTitle">{listCreateDotProject.title}</div>
                )}
                {listCreateDotProject.subtitle && (
                    <div className={clsx('default-dotListColorSubtitle', customClass)}>
                        {listCreateDotProject.subtitle}
                    </div>
                )}
                {listCreateDotProject.list.map(item => (
                    <div key={item.numeric} className="default-dotListItem">
                        <div className="default-dotListItemDot">{item.numeric}</div>
                        <div
                            dangerouslySetInnerHTML={{ __html: item.text }}
                            className="default-dotListItemText"
                        />
                    </div>
                ))}
            </div>
        </FullWrapper>
    );
};

export default DefaultDotList;
